import * as CONSTANTS from './constants';

declare global {
    interface Window {
        dataLayer: unknown[];
        gtag: (...args: unknown[]) => void;
    }
}

const GA_ID = CONSTANTS.GA_ID;

/** Injects the GA4 gtag.js script and configures the measurement ID. Call once at app startup. */
export function initGA(): void {
    if (!GA_ID) return;

    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() { window.dataLayer.push(arguments); }; // eslint-disable-line prefer-rest-params
    window.gtag('js', new Date());
    window.gtag('config', GA_ID, { send_page_view: false });

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(script);
}

/** Send a page_view hit. Call on every route change. */
export function trackPageView(path: string, title?: string): void {
    if (!GA_ID || typeof window.gtag !== 'function') return;
    window.gtag('event', 'page_view', {
        page_path: path,
        page_title: title ?? document.title,
        page_location: window.location.href,
    });
}

/** Send a custom GA4 event. */
export function trackEvent(name: string, params?: Record<string, unknown>): void {
    if (!GA_ID || typeof window.gtag !== 'function') return;
    window.gtag('event', name, params);
}
